"use client";

import { FC, type JSX } from "react";
import classNames from "classnames";
import { SectionProps } from "../Section";
import { Accordion } from "@/components/Accordion";
import { PortableText } from "@/portable-text/PortableText";
import { ContentData } from "@/cms/types";
import { AccordionSectionQueryResult } from "@/cms/sanity.types";
import { Section } from "@/components/Section";

export type AccordionSectionProps = ContentData<AccordionSectionQueryResult> &
  Omit<SectionProps, "_id">;

export const AccordionSection: FC<
  AccordionSectionProps & JSX.IntrinsicElements["section"]
> = ({
  data: { _id, internalTitle, accordions, title, container, variant },
  index,
}) => {
  return (
    <Section
      trackingData={{
        ui: {
          item_id: _id ?? "section-id-missing",
          item_name:
            internalTitle?.replaceAll(" ", "-") ?? "section-title-missing",
          item_type: "accordion-section",
          index: index,
        },
      }}
      className={classNames("w-full bg-body sm:overflow-visible")}
    >
      <div className="flex w-full flex-col items-center xs:p-3 sm:p-3">
        <div
          className={classNames("w-full", {
            "lg:mx-body lg:w-body": container === "default",
          })}
        >
          <div className="flex w-full flex-col gap-3 lg:mx-auto lg:w-body">
            <h3
              className={classNames("heading-03", {
                "text-[var(--fg-primary)]": variant === "color",
              })}
            >
              {title}
            </h3>
            {accordions?.map(
              ({ _id, title, icon, accordionText }, accordionIndex) => (
                <Accordion
                  key={`${_id}-${accordionIndex}`}
                  index={index}
                  icon={icon}
                  title={title}
                >
                  <PortableText value={accordionText ?? []} />
                </Accordion>
              ),
            )}
          </div>
        </div>
      </div>
    </Section>
  );
};

export default AccordionSection;
